import React, { useState, useEffect, useContext } from 'react';
import Blogsidebar from './Blog_sidebar';
import Header from '../layout/Header';
import ReactMarkdown from 'react-markdown';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { BlogCtx } from '../../context/BlogCtx';
import { useHistory } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Error from '../pages/Error';

const BlogCaseDetails = () => {
    const history = useHistory();
    const {archiveChangeHandler, categoryChangeHandler} = useContext(BlogCtx)
    const [doc, setDoc] = useState(history.location.state?.doc);
    const [pageName, setPageName] = useState(history.location.state?.pageName);
    const [content, setContent] = useState('');
    const location = useLocation();
    const pathSegments = location.pathname.split('/').filter(Boolean);
    const blogName = pathSegments[pathSegments.length - 1] + '/';
    const handleChangeCategory = (categorie) => {
        categoryChangeHandler(categorie)
        archiveChangeHandler("")
    }
    const handleChangeArchive = (archive) => {
        archiveChangeHandler(archive)
        categoryChangeHandler("")
    }
    useEffect(() => {
        const fetchBlogs = async () => {
            try {
                setDoc(null);
                const responseData = await axios.post(
                    `${process.env.REACT_APP_API_URL}/get/blogs`,
                    {
                        limit: 5,
                        start: 0,
                        url: blogName,
                        token: process.env.REACT_APP_BACKEND_TOKEN_GET
                    },
                    {
                        headers: {
                            Authorization: process.env.REACT_APP_BACKEND_TOKEN,
                        },
                    }
                );
                const singleBlog = responseData.data?.data.find(
                    (study) => study.URL === blogName
                );
                if (singleBlog) {
                    const pattern = process.env.REACT_APP_STRAPI_REGEX;
                    const apiUrl = process.env.REACT_APP_STRAPI_URL;
                    if (pattern && apiUrl) {
                      const strapiRegex = new RegExp(pattern, 'g');
                      const replacedContent = singleBlog.content?.replace(strapiRegex, apiUrl);                  
                      setContent(replacedContent);
                    }                  
                    setPageName('blog');
                    setDoc(singleBlog);
                }
                else {
                    history.replace('/404');
                }
            } catch (error) {
                // Error handling can be improved as needed
            }
        };

        fetchBlogs();
    }, [blogName]);
    
        return (
            <>
            <Helmet>
                <title>{doc?.title || ""} - Thinqloud</title>
            </Helmet>
            {doc ? (
            <div className="site-main">
                <Header />
                <div className="ttm-page-title-row ttmpagetitlerow5">
                    <div className="container-xl">
                        <div className="row">
                            <div className="col-md-12"> 
                                <div className="title-box text-center">
                                    <div className="page-title-heading">
                                        <h1 className="title  sh2">Blogs</h1>
                                        <h1 className="title sh2 displyNone">{doc?.title || ""}</h1>
                                          <p className="banner-subtitle pText">
                      {doc.title}
                    </p>
                                    </div>
                                    <div className="breadcrumb-wrapper">
                                        <span>
                                            <a title="Homepage" href={process.env.PUBLIC_URL + "/"}><i className="ti ti-home" />&nbsp;&nbsp;Home</a>
                                        </span>
                                        <span className="ttm-bread-sep">&nbsp; : : &nbsp;</span>
                                        <span>Blogs</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>                      
                </div>
                <div className="sidebar ttm-bgcolor-white clearfix">
                    <div className="container-xl">
                        <div className="row">
                            <div className="col-lg-9 content-area">
                                <article className="post ttm-blog-single clearfix">
                                    <div className="ttm-post-featured-wrapper">
                                        <div className="ttm-post-featured">
                                            <img className="img-fluid" src={`${process.env.REACT_APP_STRAPI_URL}${doc.blog_images?.[0]?.url}`} alt="post-01" />
                                        </div>
                                    </div>
                                    <div className="ttm-blog-single-content">
                                        <div className="entry-content">
                                            <div className="ttm-post-entry-header">
                                                <div className="post-meta">
                                                    <span className="ttm-meta-line byline"><i className="fa fa-user" />{doc.author_name}</span>                                                    
                                                    <span className="ttm-meta-line entry-date"><i className="fa fa-calendar" /><time className="entry-date published">{ new Date(doc.created_date).toLocaleDateString('en-GB')}</time></span>
                                                    <span className="ttm-meta-line tags-links"><i className="far fa-comment" />{ doc.blog_categories?.[0]?.Blog_category}</span>
                                                </div>
                                            </div>                                        
                                        </div>
                                    </div>
                                </article>
                                <ReactMarkdown className="contentData">                                
                               {content}
                                </ReactMarkdown>
                            </div>
                            <div className="col-lg-3 widget-area">
                                <Blogsidebar changeCategory={handleChangeCategory} changeArchivies={handleChangeArchive} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>  
        ) : <Error />}
            </>
        )
    }

export default BlogCaseDetails;